module.exports = __webpack_public_path__ + "img/4_172.1a94528b.png";